import { IInlineSearchMutations } from '@/interfaces/mutations.interface';
import state from './state';
import { Suggestion } from '@/interfaces/suggestion.interface';

const mutations: IInlineSearchMutations = {
	setAmIVisible: (value) => state.amIVisible = value,
	setText: (text) => state.text = text,
	setResults: (tab, results) => {
		state.results[tab] = results;
	},
	setTabResultsAmount: (tab, amount) => {
		const tabEntry = state.tabs.find((t) => t.id === tab);

		if (!tabEntry) return;

		tabEntry.amount = amount;
	},
	setSelectedTab: (tab) => {
		state.selectedTab = tab;
	},
	setUserData: (userData) => {
		if (!state.userData) {
			state.userData = userData;
		} else {
			state.userData = {
				...state.userData,
				...userData,
			};
		}
	},
	setFacets: (facets) => state.facets = facets,
	setGAIQuestionnaireTaken: (isTaken) => state.isGAIQuestionnaireTaken = isTaken,
	setDependenciesReady: (isReady) => state.dependenciesReady = isReady,
	setProgrammeSearchInput: (filters) => state.programmeSearchInput = filters,
	setSuggestions: (suggestions: Suggestion[]) => state.suggestions = suggestions,
	setUserKeyboardEvent: (event: KeyboardEvent) => state.userKeyboardEvent = event,
};

export default mutations;